import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
interface FooterProps {
  onPrivacyClick: () => void;
  onTermsClick: () => void;
}
export function Footer({
  onPrivacyClick,
  onTermsClick
}: FooterProps) {
  const {
    t
  } = useTranslations();
  return <footer className="bg-[#064E3B] text-white pt-16 pb-8" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-179">
          {/* Brand */}
          <div className="col-span-1 lg:col-span-1" data-id="element-180">
            <div className="flex items-center mb-6" data-id="element-181">
              <img src="https://cdn.magicpatterns.com/uploads/oxFWMvdwUBRjCt1riBg7DA/Asset_44x.png" alt="Brixen Funding" className="h-8 w-auto brightness-0 invert" data-id="element-182" />
            </div>
            <p className="text-gray-300 text-sm mb-6" data-id="element-183">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4" data-id="element-184">
              <a href="#" className="text-gray-400 hover:text-[#00E676] transition-colors" data-id="element-185">
                <Facebook className="w-5 h-5" data-id="element-186" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E676] transition-colors" data-id="element-187">
                <Twitter className="w-5 h-5" data-id="element-188" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E676] transition-colors" data-id="element-189">
                <Linkedin className="w-5 h-5" data-id="element-190" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E676] transition-colors" data-id="element-191">
                <Instagram className="w-5 h-5" data-id="element-192" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-193">
            <h4 className="text-lg font-bold mb-6" data-id="element-194">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-195">
              <li data-id="element-196">
                <a href="#about" className="hover:text-[#00E676] transition-colors" data-id="element-197">
                  {t('nav.aboutUs')}
                </a>
              </li>
              <li data-id="element-198">
                <a href="#funding" className="hover:text-[#00E676] transition-colors" data-id="element-199">
                  {t('nav.funding')}
                </a>
              </li>
              <li data-id="element-200">
                <a href="#how-it-works" className="hover:text-[#00E676] transition-colors" data-id="element-201">
                  {t('nav.howItWorks')}
                </a>
              </li>
              <li data-id="element-202">
                <a href="#testimonials" className="hover:text-[#00E676] transition-colors" data-id="element-203">
                  {t('nav.testimonials')}
                </a>
              </li>
              <li data-id="element-204">
                <a href="#contact" className="hover:text-[#00E676] transition-colors" data-id="element-205">
                  {t('contact.email')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-206">
            <h4 className="text-lg font-bold mb-6" data-id="element-207">{t('footer.contact')}</h4>
            <ul className="space-y-3 text-sm text-gray-300" data-id="element-208">
              <li data-id="element-209">390 NE 191ST ST STE 8123</li>
              <li data-id="element-210">Miami, FL 33179</li>
              <li data-id="element-211">(800) 326-0670</li>
              <li data-id="element-212">(645) 248-3829</li>
              <li data-id="element-213">info@brixenfunding.com</li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-214">
            <h4 className="text-lg font-bold mb-6" data-id="element-215">{t('footer.hoursTitle')}</h4>
            <p className="text-sm text-gray-300 mb-2" data-id="element-216">{t('footer.hoursDay')}</p>
            <p className="text-lg font-semibold text-[#00E676]" data-id="element-217">
              {t('footer.hoursTime')}
            </p>
            <p className="text-sm text-gray-400 mt-4" data-id="element-218">
              {t('footer.hoursClosed')}
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 mt-8" data-id="element-219">
          {/* Disclaimer Text - Above Copyright */}
          <div className="mb-8 text-xs text-gray-400 text-center max-w-5xl mx-auto leading-relaxed space-y-4" data-id="element-220">
            <p data-id="element-221">{t('footer.disclaimer1')}</p>
            <p data-id="element-222">{t('footer.disclaimer2')}</p>
            <p data-id="element-223">{t('footer.disclaimer3')}</p>
          </div>

          {/* Copyright and Links */}
          <div className="flex flex-col md:flex-row justify-between items-center pt-6 border-t border-gray-700" data-id="element-224">
            <p className="text-xs text-gray-400 text-center md:text-left mb-4 md:mb-0" data-id="element-225">
              {t('footer.copyright')}
            </p>
            <div className="flex space-x-6 text-xs text-gray-400" data-id="element-226">
              <button onClick={onPrivacyClick} className="hover:text-white transition-colors cursor-pointer" data-id="element-227">
                {t('footer.privacy')}
              </button>
              <button onClick={onTermsClick} className="hover:text-white transition-colors cursor-pointer" data-id="element-228">
                {t('footer.terms')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}